// @flow

// NOTE: This Flow module has a corresponding ambient TypeScript declaration in app/types/flow-modules.d.ts. Keep them in sync until this file is migrated to TypeScript.

import { getPhoneNumberNormalizerWithLength } from '@tectonics/commons/customer-form/get-phone-number-normalizer';
import { LATAM_PHONE_MASK } from '@tectonics/commons/masks';
import type { PhoneNumberConfig } from './types';

export const genericPhoneNumber: PhoneNumberConfig = {
  inputFieldName: 'genericPhoneNumber',
  labelKey: 'volcanes.customerForm.phoneNumber.label',
  placeholderKey: 'volcanes.customerForm.phoneNumber.placeholder',
  normalizer: getPhoneNumberNormalizerWithLength(20),
  mask: LATAM_PHONE_MASK,
};
